<div class="fullcontainer">
  <div class="titleContainer">
    <h1 class="header">System Settings &amp; Administration</h1>
  </div>

  @for (section of this.settingsSections; track section.title) {
    <div class="sheet">
      <h2 class="header" style="font-size: 1.15rem;">{{ section.title }}</h2>
      <div class="row">
        @for (item of section.items; track item.name) {
          <div class="col-4 mb-3">
            <button class="btn btn-block btn-primary" [routerLink]="item.link">
              <i [class]="item.icon"></i> {{ item.name }}
            </button>
            <small class="text-muted d-block mt-1">{{ item.description }}</small>
          </div>
        }
      </div>
    </div>
  }
</div>
